import PropTypes from 'prop-types';
import React from 'react';

import {pushInteractionTagManager} from '../../services/tagManager';
import {AccreditationButton} from '../AccreditationButton';
import './NavMenu.style.scss';

export const NavMenu = (props) => {
  const headerButton = {
    screenName: 'credenciamento:home',
    elementType: 'header:button:click'
  };

  return (
    <nav className="nav-menu">
      <a
        className="nav-menu__link"
        onClick={() =>
          pushInteractionTagManager({
            ...headerButton,
            elementContent: 'none:maquininhas:none'
          })
        }
        href="#maquininhas"
      >
        Maquininhas
      </a>
      <a
        className="nav-menu__link"
        onClick={() =>
          pushInteractionTagManager({
            ...headerButton,
            elementContent: 'none:documentos:none'
          })
        }
        href="#documentos"
      >
        Documentos
      </a>
      <a
        className="nav-menu__link"
        onClick={() =>
          pushInteractionTagManager({
            ...headerButton,
            elementContent: 'none:vantagens:none'
          })
        }
        href="#vantagens"
      >
        Vantagens
      </a>
      <a
        className="nav-menu__link nav-menu__link--margin-right"
        onClick={() =>
          pushInteractionTagManager({
            ...headerButton,
            elementContent: 'none:faq:none'
          })
        }
        href="#faq"
      >
        FAQ
      </a>
      <AccreditationButton
        {...props}
        elementType={headerButton.elementType}
        elementContent="none:quero-me-credenciar:header"
      />
    </nav>
  );
};

NavMenu.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func
};
